export default __webpack_public_path__ + "static/punjabsweetsvertical-9745224a734f7594631889c81fe2fad2.svg";